export default __webpack_public_path__ + "static/media/Olympus Logo.c93ee5f2.svg";